export const NAME_COLUMN = () => ({
  key: 'name',
  value: 'Name',
})

export const REMOVE_COLUMN = () => ({
  key: 'remove',
  value: '',
})
